// extracted by mini-css-extract-plugin
export var container = "FallingSquare-module--container--fRbFw";
export var squareWrap = "FallingSquare-module--squareWrap--rSfYT";
export var transition = "FallingSquare-module--transition--mFhQk";